'use strict';

var windowWidth = $(window).innerWidth;

/**
 * Generates responsive settings for a carousel based on the provided options for dots and arrows.
 *
 * @param {boolean} dots - Specifies whether dots (pagination indicators) should be enabled.
 * @param {boolean} arrows - Specifies whether arrows (navigation controls) should be enabled.
 * @param {number} productsCount to show the tiles
 * @returns {Array<Object>} - An array containing responsive settings for the carousel.
 */
function getResponsiveSettings(dots, arrows) {
    const isDots = dots;
    const isArrows = arrows;
    return [
        {
            breakpoint: 768,
            settings: {
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: isDots,
                arrows: isArrows,
                draggable: false,
                swipe: true
            }
        },
        {
            breakpoint: 1024,
            settings: {
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: isDots,
                arrows: isArrows,
                draggable: false,
                swipe: true
            }
        }
    ];
}

/**
 * creating the setting for different pages
 * @param {number} maxSlides to be slick
 * @param {number} productsCount to show the tiles
 * @returns {number} remainingProducts
 */
function getRemainingProducts(maxSlides, productsCount) {
    var productsToShow = (windowWidth && windowWidth > 1279) ? maxSlides : 2;
    return Math.max(0, productsToShow - productsCount);
}

/**
 * Unslicks  PLP carousel and adds visibility class
 * @param {Object} carousel plp carousel object
 */
function unslickPLPCarousel(carousel) {
    // Add is visibile class
    $(carousel).addClass('invisible');
    $(carousel).parent().prev('.py-einstein-carousel-header').addClass('invisible');
    $(carousel).slick('unslick');
}

/**
 * creating the setting for different pages
 * @param {number} count to show the tiles
 * @param {jQuery} carousel to be slick
 */
function appendPlaceholders(count, carousel) {
    if ($(carousel).hasClass('slick-initialized')) {
        $(carousel).slick('unslick');
    }
    for (let i = 0; i < count; i += 1) {
        jQuery('<div>', {}).appendTo($(carousel));
    }
}

/**
 * creating the setting for different pages
 * @param {number} productsCount to show the tiles
 * @param {jQuery} carousel to be slick
 * @returns {Object} settings
 */
function slickCarouselSettings(productsCount, carousel) {
    var maxSlides = 4;
    var settings = {};

    if (!maxSlides || !productsCount || !carousel) {
        return {};
    }

    const remainingProducts = getRemainingProducts(maxSlides, productsCount, windowWidth);
    appendPlaceholders(remainingProducts, carousel);

    $(carousel).next().removeClass('d-lg-none').addClass('d-lg-block');
    settings = {
        dots: false,
        infinite: false,
        slidesToShow: maxSlides,
        slidesToScroll: 4,
        arrows: true,
        nextArrow: $(carousel).parent().find('.next-slide') || null,
        prevArrow: $(carousel).parent().find('.previous-slide') || null,
        responsive: getResponsiveSettings(true, false, productsCount)
    };

    return settings;
}

module.exports = {
    slickCarouselSettings: slickCarouselSettings,
    unslickPLPCarousel: unslickPLPCarousel
};
